// extracted by mini-css-extract-plugin
module.exports = {"sceneWrapper":"HobbiesScene_sceneWrapper__2qqkG"};